module.exports = __webpack_public_path__ + "static/img/membership_jifen.b657e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership_jifen.png
// module id = fo/k
// module chunks = 1